import { useParams } from 'react-router-dom';

import CertificationRow from '@/app/certification/CertificationRow';

import { useCoachActivity } from '@/data/coachActivity';

const Qualifications = () => {
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);

  return (
    <div className="w-full">
      <h2 className="text-2xl font-bold mb-8">Qualifications</h2>
      <div className="flex flex-col gap-4 mb-6 max-w-[500px]">
        {coachActivity.data.certifications.map((certification) => (
          <CertificationRow
            certification={certification}
            key={certification.id}
          />
        ))}
      </div>
    </div>
  );
};

export default Qualifications;
